import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-icon',
  templateUrl: './nav-icon.component.html',
  styleUrls: ['./nav-icon.component.scss'],
  standalone: false,
})
export class NavIconComponent {
  @Input({ required: true }) icon!: string | undefined;
  @Input({ required: true }) route!: string | undefined;
  @Input() displayText = '';
  @Input() hasDisplayText = false;

  constructor(private router: Router) {}

  get isActive() {
    return this.router.url.includes(this.route as string);
  }

  get link() {
    return `${this.route}`;
  }
}
